export default "__VITE_ASSET__CjFUHhOH__"